import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChatInputModule } from '../chat-input/chat-input.module';
import { ChatMessageModule } from '../chat-message/chat-message.module';
import { ChatResolveButtonModule } from '../chat-resolve-button/chat-resolve-button.module';
import { ChatRoomComponent } from './chat-room.component';

@NgModule({
  declarations: [ChatRoomComponent],
  imports: [CommonModule, ChatInputModule, ChatMessageModule, ChatResolveButtonModule],
  exports: [ChatRoomComponent],
})
export class ChatRoomModule {}
